import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    id: 0,
    title: "",
    participantsCount: 0,
    prizePlacesCount: 0,
    totalAmount: 0,
    currentAmount: 0,
    status: "PENDING",
    winnersCount: 0,
    durationDays: 0,
    tokenType: "",
    creatorUserId: 1,
    link: "put here link telegram channel or group",
    maxParticipantsCount: 0,
    category: {
        category_name: "",
        positions: [],
    },
    promoType: "crystalsAndCrypto",
    promoters: [],
    startDate: null,
    // Blockchain fields
    chainId: null,
    tokenContractAddress: null,
    promoterAddress: null,
};

const promoFormSlice = createSlice({
    name: "promoForm",
    initialState,
    reducers: {
        // Обновить одно поле
        setPromoField: (state, action) => {
            const {field, value} = action.payload;
            state[field] = value;
        },

        // Обновить вложенное поле category
        setCategoryField: (state, action) => {
            const {field, value} = action.payload;
            state.category[field] = value;
        },

        // Добавить новую позицию в category.positions
        addCategoryPosition: (state, action) => {
            state.category.positions.push(action.payload);
        },

        // Обновить существующую позицию в category.positions по индексу
        updateCategoryPosition: (state, action) => {
            const {
                index,
                field,
                value,
                winners,
                winPercent,
                budget,
                budgetPercent,
                dropPerWinner,
            } = action.payload;
            const item = state.category.positions[index];
            state.category.positions[index] = {
                ...item,
                [field]: value,
                ...(winners !== undefined ? {winners} : {}),
                ...(winPercent !== undefined ? {winPercent} : {}),
                ...(budget !== undefined ? {budget} : {}),
                ...(budgetPercent !== undefined ? {budgetPercent} : {}),
                ...(dropPerWinner !== undefined ? {dropPerWinner} : {}),
            };
        },

        // Удалить позицию из category.positions по индексу
        removeCategoryPosition: (state, action) => {
            state.category.positions.splice(action.payload, 1);
        },

        // Обновить несколько полей сразу
        updatePromoFields: (state, action) => {
            return {...state, ...action.payload};
        },

        // Установить полную форму
        setPromoForm: (state, action) => {
            return {...initialState, ...action.payload};
        },

        // Заменить все позиции в категории
        updateAllCategoryPositions: (state, action) => {
            state.category.positions = [...action.payload];
        },

        // ===== Новые редьюсеры для promoters =====

        // Заменить весь массив промоутеров
        setPromoters: (state, action) => {
            state.promoters = action.payload;
        },

        // Добавить одного промоутера
        addPromoter: (state, action) => {
            state.promoters.push(action.payload);
        },

        // Обновить поле конкретного промоутера по индексу
        updatePromoter: (state, action) => {
            const {index, field, value} = action.payload;
            state.promoters[index][field] = value;
        },
        reorderPromoters: (state, action) => {
            const {fromIndex, toIndex} = action.payload;
            const item = state.promoters.splice(fromIndex, 1)[0];
            state.promoters.splice(toIndex, 0, item);
        },
        // пример редьюсера
        syncPromoterData: (state, action) => {
            const { index, name, logo } = action.payload;
            state.promoters[index].name = name;
            state.promoters[index].logo = logo;
        },
        // Удалить промоутера по индексу
        removePromoter: (state, action) => {
            state.promoters.splice(action.payload, 1);
        },

        // Очистить форму (сбросить к дефолту)
        resetPromoForm: () => initialState,
    },
});

export const {
    setPromoField,
    setCategoryField,
    addCategoryPosition,
    updateCategoryPosition,
    removeCategoryPosition,
    updatePromoFields,
    setPromoForm,
    updateAllCategoryPositions,
    syncPromoterData,
    reorderPromoters,
    setPromoters,
    addPromoter,
    updatePromoter,
    removePromoter,
    resetPromoForm,
} = promoFormSlice.actions;

export default promoFormSlice.reducer;
